(function() {
  function addPhotosToCarousel() {
    if (!window.jdgmCarouselMode) return;
    
    const carousels = Object.keys(window.jdgmCarouselMode);
    carousels.forEach(function(key) {
      const mode = window.jdgmCarouselMode[key];
      if (!mode || !mode.reviews) return;
      
      mode.reviews.forEach(function(review) {
        if (!review.pictures_urls || review.pictures_urls.length === 0) return;
        
        const card = document.querySelector(
          `.jdgm-carousel-item[data-review-id="${review.uuid}"] .jdgm-card-content`
        );
        if (!card || card.querySelector('.jdgm-rev__pics')) return;
        
        const picsDiv = document.createElement('div');
        picsDiv.className = 'jdgm-rev__pics';
        review.pictures_urls.forEach(function(pic) {
          const img = document.createElement('img');
          img.src = pic.small;
          img.alt = 'recensione';
          img.loading = 'lazy';
          picsDiv.appendChild(img);
        });
        
        const ratingSection = card.querySelector('.jdgm-rating-section');
        if (ratingSection) {
          card.insertBefore(picsDiv, ratingSection);
        } else {
          card.appendChild(picsDiv);
        }
      });
    });
  }

  // Aspetta che il carosello sia caricato
  let attempts = 0;
  const interval = setInterval(function() {
    attempts++;
    const cards = document.querySelectorAll('.jdgm-carousel-item');
    if (cards.length > 0) {
      addPhotosToCarousel();
      clearInterval(interval);
    }
    if (attempts > 40) clearInterval(interval);
  }, 250);
})();
